import config from '@/assets/config'
import { getFrames, copyFrames } from '@/utils'

const ww = window.innerWidth
const wh = window.innerHeight

// 场景基础数据
const s5ScrollD = config.scenesScrollD[4]
const s5ScrollT = config.scenesScrollT[4]

// 淡入
const s5FadeInD = s5ScrollD - s5ScrollT * 0.1
const s5FadeInT = s5ScrollT * 0.1

// 向左移动
const s5BgMoveT = s5ScrollT * 0.15 // 0.3T
const s5BgW = wh * 2125 / 2436
const s5BgX = ww - s5BgW
const s5BgX2 = 0
const s5BgScrollW = s5BgX2 - s5BgX

const s5FatherX = 390 / 2125 * s5BgW + s5BgX
const s5MotherX = 620 / 2125 * s5BgW + s5BgX
const s5Me1X = 60 / 2125 * s5BgW + s5BgX
const s5Me2X = 64 / 2125 * s5BgW + s5BgX

// 对话
const s5Talk1X = 260 / 2125 * s5BgW + s5BgX
const s5Talk2X = 868 / 2125 * s5BgW + s5BgX
const s5Talk1D = s5ScrollD + s5BgMoveT // 0.15T
const s5Talk1T = s5ScrollT * 0.08
const s5Talk1H = wh * 0.383
const s5Talk1W = s5Talk1H * 202 / 934
const s5Talk2D = s5Talk1D + s5ScrollT * 0.08
const s5Talk2T = s5ScrollT * 0.08
const s5Talk2H = wh * 0.249
const s5Talk2W = s5Talk2H * 248 / 607

// 淡入淡出
const s5FadeD = s5Talk1D + s5ScrollT * 0.4 // 0.55T
const s5FadeT = s5ScrollT * 0.15

// 转账
const s5MoneyD = s5FadeD + s5FadeT // 0.7T
const s5MoneyT = s5ScrollT * 0.05
const s5MoneyX = 531 / 2125 * s5BgW + s5BgX
const s5MoneyH = wh * 0.136
const s5MoneyW = s5MoneyH * 580 / 332

// 文字
const s5TextD = s5MoneyD + s5MoneyT // 0.75T
const s5TextT = s5ScrollT * 0.05
const s5TextX = 88 / 2125 * s5BgW + s5BgX

// 淡出
// 场景基础数据
const s6ScrollD = config.scenesScrollD[5]
const s6ScrollT = config.scenesScrollT[5]
// 旋转缩放
const s6RotateD = s6ScrollD
const s6RotateT = s6ScrollT * 0.1
const s5FadeOutD = s6RotateD + s6RotateT
const s5FadeOutT = s6RotateT

const animations = {
  s5_bg: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5BgX },
      to: { x: s5BgX2 }
    },
    {
      delay: s5FadeOutD,
      duration: s5FadeOutT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s5FadeInD,
      duration: s5FadeInT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s5_father: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5FatherX },
      to: { x: s5FatherX + s5BgScrollW }
    },
    {
      delay: s5FadeD,
      duration: s5FadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s5FadeInD,
      duration: s5FadeInT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s5_mother: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5MotherX },
      to: { x: s5MotherX + s5BgScrollW }
    },
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      frames: copyFrames(getFrames('s5_mother', 2, 1), 2)
    },
    {
      delay: s5FadeD,
      duration: s5FadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s5FadeInD,
      duration: s5FadeInT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s5_me1: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5Me1X },
      to: { x: s5Me1X + s5BgScrollW }
    },
    {
      delay: s5FadeD,
      duration: s5FadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s5FadeInD,
      duration: s5FadeInT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s5_me2: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5Me2X },
      to: { x: s5Me2X + s5BgScrollW }
    },
    {
      delay: s5FadeOutD,
      duration: s5FadeOutT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s5FadeD,
      duration: s5FadeT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s5_money: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5MoneyX },
      to: { x: s5MoneyX + s5BgScrollW }
    },
    {
      delay: s5FadeOutD,
      duration: s5FadeOutT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s5MoneyD,
      duration: s5MoneyT,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s5MoneyW, height: s5MoneyH }
    }
  ],
  s5_textnew: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5TextX },
      to: { x: s5TextX + s5BgScrollW }
    },
    {
      delay: s5FadeOutD,
      duration: s5FadeOutT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    },
    {
      delay: s5TextD,
      duration: s5TextT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    }
  ],
  s5_talk1: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5Talk1X },
      to: { x: s5Talk1X + s5BgScrollW }
    },
    {
      delay: s5Talk1D,
      duration: s5Talk1T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s5Talk1W, height: s5Talk1H, yoyo: true, repeat: 1, repeatDelay: s5Talk1T * 2, ease: 'ease' }
    }
  ],
  s5_talk2: [
    {
      delay: s5ScrollD,
      duration: s5BgMoveT,
      from: { x: s5Talk2X },
      to: { x: s5Talk2X + s5BgScrollW }
    },
    {
      delay: s5Talk2D,
      duration: s5Talk2T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s5Talk2W, height: s5Talk2H, yoyo: true, repeat: 1, repeatDelay: s5Talk2T * 2, ease: 'ease' }
    }
  ]
}

export default animations



// WEBPACK FOOTER //
// ./src/assets/scenes/s5/spritesAnimations.js